<template>
  <v-container fluid>
    <v-card>
      <v-card-title class="primary white--text">
        Asignaciones V8 - Vista Ejecutivo
        <v-spacer></v-spacer>
        <div class="d-flex align-center mr-4">
          <span class="white--text caption mr-2">Resumido</span>
          <v-switch v-model="modoDetallado" hide-details dense dark color="white" class="mt-0 pt-0"></v-switch>
          <span class="white--text caption ml-1">Detallado</span>
        </div>
        <v-btn color="success" @click="exportarExcel" :disabled="!resumenEjecutivo.length" :loading="exporting" small class="mr-2">
          <v-icon left>mdi-file-excel</v-icon> Exportar Resumen
        </v-btn>
        <v-btn color="red darken-2" @click="exportarPDF" :disabled="!resumenEjecutivo.length" :loading="exportandoPDF" small>
          <v-icon left>mdi-file-pdf-box</v-icon> Exportar PDF
        </v-btn>
      </v-card-title>
      
      <!-- Filtros de Fecha únicamente -->
      <v-card-text class="pt-4">
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="filtros.fecha_inicio_mes"
              label="Fecha Inicio Mes"
              type="date"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="filtros.fecha_consulta"
              label="Fecha Consulta"
              type="date"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="d-flex align-center">
            <v-btn color="primary" @click="fetchData" :loading="loading" large block>
              <v-icon left>mdi-magnify</v-icon> Consultar Resumen
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <!-- Filtros -->
      <v-card-text v-if="records.length > 0" class="pt-0">
        <v-row dense align="center">
          <v-col cols="12" md="3">
            <v-text-field v-model="busqueda" label="Buscar estudiante, documento, correo o programa"
              prepend-inner-icon="mdi-magnify" outlined dense clearable hide-details></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-select v-model="filtroUnidad" :items="opcionesUnidad" label="Unidad" outlined dense hide-details
              multiple small-chips deletable-chips clearable></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-select v-model="filtroSede" :items="opcionesSede" label="Sede" outlined dense hide-details
              multiple small-chips deletable-chips clearable></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-select v-model="filtroAsignacion" :items="opcionesAsignacion" label="Tipo Asignación" outlined dense hide-details
              multiple small-chips deletable-chips clearable></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-select v-model="filtroEstado" :items="opcionesEstado" label="Estado" outlined dense hide-details
              multiple small-chips deletable-chips clearable></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-select v-model="filtroTipoPlan" :items="opcionesTipoPlan" label="Tipo Plan" outlined dense hide-details
              multiple small-chips deletable-chips clearable></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-select v-model="filtroConceptos" :items="opcionesConcepto" item-text="text" item-value="value"
              label="Conceptos" multiple small-chips deletable-chips clearable outlined dense hide-details></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-btn color="error" outlined block @click="limpiarFiltros">
              <v-icon left>mdi-filter-remove</v-icon>Limpiar
            </v-btn>
          </v-col>
          <v-col cols="12" md="2" class="text-right">
            <v-chip color="primary" outlined small>
              {{ datosFiltrados.length }} de {{ records.length }} registros
            </v-chip>
          </v-col>
        </v-row>
      </v-card-text>

      <!-- KPI Cards -->
      <v-card-text v-if="resumenEjecutivo.length > 0" class="pb-0">
        <v-row dense>
          <v-col cols="6" sm="3">
            <v-card outlined class="text-center pa-3">
              <v-icon color="primary" class="mb-1">mdi-currency-usd</v-icon>
              <div class="caption grey--text">Total Asignado</div>
              <div class="text-h6 primary--text font-weight-bold">{{ formatMonto(totalesGenerales.asignacion) }}</div>
              <div class="caption grey--text">Bs.</div>
            </v-card>
          </v-col>
          <v-col cols="6" sm="3">
            <v-card outlined class="text-center pa-3">
              <v-icon color="success" class="mb-1">mdi-cash-check</v-icon>
              <div class="caption grey--text">Total Cobrado</div>
              <div class="text-h6 success--text font-weight-bold">{{ formatMonto(totalesGenerales.monto_pagado) }}</div>
              <div class="caption grey--text">Bs.</div>
            </v-card>
          </v-col>
          <v-col cols="6" sm="3">
            <v-card outlined class="text-center pa-3">
              <v-icon :color="getColorPorcentaje(totalesGenerales.porcentaje)" class="mb-1">mdi-percent</v-icon>
              <div class="caption grey--text">Cobranza Global</div>
              <div class="text-h6 font-weight-bold" :class="getColorPorcentaje(totalesGenerales.porcentaje) + '--text'">
                {{ totalesGenerales.porcentaje.toFixed(1) }}%
              </div>
              <v-progress-linear :value="totalesGenerales.porcentaje" :color="getColorPorcentaje(totalesGenerales.porcentaje)" height="4" rounded class="mt-1"></v-progress-linear>
            </v-card>
          </v-col>
          <v-col cols="6" sm="3">
            <v-card outlined class="text-center pa-3">
              <v-icon color="info" class="mb-1">mdi-account-group</v-icon>
              <div class="caption grey--text">Estudiantes únicos</div>
              <div class="text-h6 info--text font-weight-bold">{{ totalesGenerales.cantidad_estudiantes }}</div>
              <div class="caption grey--text">registros: {{ totalesGenerales.cantidad_registros }}</div>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <!-- Gráfico Resumen -->
      <v-card-text v-show="records.length > 0">
        <div v-if="unidadSeleccionada" class="d-flex align-center mb-3">
          <v-btn text small color="primary" @click="unidadSeleccionada = null">
            <v-icon left small>mdi-arrow-left</v-icon> Todas las unidades
          </v-btn>
          <v-icon small class="mx-1 grey--text">mdi-chevron-right</v-icon>
          <span class="font-weight-bold primary--text">{{ unidadSeleccionada }}</span>
          <v-chip x-small color="primary" outlined class="ml-2">Sedes</v-chip>
        </div>
        <div v-if="records.length > 0" class="d-flex align-center flex-wrap gap-2 mb-2">
          <span class="caption grey--text mr-1">Tipo:</span>
          <v-chip-group v-model="filtroAsignacion" active-class="primary white--text" multiple>
            <v-chip v-for="op in tiposAsignacionChips" :key="op.value" :value="op.value" small filter>
              {{ op.text }}
            </v-chip>
          </v-chip-group>
          <v-divider vertical class="mx-2"></v-divider>
          <span class="caption grey--text mr-1">Sede:</span>
          <v-chip-group v-model="filtroSede" active-class="teal white--text" multiple>
            <v-chip v-for="op in sedesChips" :key="op.value" :value="op.value" small filter>
              {{ op.text }}
            </v-chip>
          </v-chip-group>
        </div>
        <v-row>
          <v-col cols="12" md="7">
            <div class="d-flex align-center justify-center mb-3">
              <h3>Asignación vs Pagado vs Saldo</h3>
              <v-btn icon x-small class="ml-2" title="Exportar PNG" @click="exportarGrafico('chartUnidadNegocio', 'asignacion-pagado-saldo')">
                <v-icon small>mdi-download</v-icon>
              </v-btn>
            </div>
            <div style="position: relative; height: 360px;">
              <canvas ref="chartUnidadNegocio"></canvas>
            </div>
          </v-col>
          <v-col cols="12" md="5">
            <div class="d-flex align-center justify-center mb-3">
              <h3>Monto Cobrado por Unidad</h3>
              <v-btn icon x-small class="ml-2" title="Exportar PNG" @click="exportarGrafico('chartDoughnut', 'monto-cobrado')">
                <v-icon small>mdi-download</v-icon>
              </v-btn>
            </div>
            <div style="position: relative; height: 360px;">
              <canvas ref="chartDoughnut"></canvas>
            </div>
          </v-col>
          <v-col cols="12" md="6" class="mt-4">
            <div class="d-flex align-center justify-center mb-1">
              <h3>% Cobranza por Unidad</h3>
              <v-btn icon x-small class="ml-2" title="Exportar PNG" @click="exportarGrafico('chartPorcentaje', 'porcentaje-cobranza')">
                <v-icon small>mdi-download</v-icon>
              </v-btn>
            </div>
            <div class="d-flex justify-center mb-2">
              <v-chip x-small color="success" dark class="mr-2">≥ 80% Bueno</v-chip>
              <v-chip x-small color="warning" dark class="mr-2">≥ 50% Regular</v-chip>
              <v-chip x-small color="error" dark>&lt; 50% Crítico</v-chip>
            </div>
            <div style="position: relative; height: 240px;">
              <canvas ref="chartPorcentaje"></canvas>
            </div>
          </v-col>
          <v-col cols="12" md="6" class="mt-4">
            <div class="d-flex align-center justify-center mb-3">
              <h3>Composición de Recaudación</h3>
              <v-btn icon x-small class="ml-2" title="Exportar PNG" @click="exportarGrafico('chartStacked', 'composicion-recaudacion')">
                <v-icon small>mdi-download</v-icon>
              </v-btn>
            </div>
            <div style="position: relative; height: 240px;">
              <canvas ref="chartStacked"></canvas>
            </div>
          </v-col>
          <v-col cols="12" class="mt-4">
            <div class="d-flex align-center justify-center mb-1">
              <h3>Riesgo de Cobranza por Unidad</h3>
              <v-btn icon x-small class="ml-2" title="Exportar PNG" @click="exportarGrafico('chartBubble', 'riesgo-cobranza')">
                <v-icon small>mdi-download</v-icon>
              </v-btn>
            </div>
            <p class="text-center caption grey--text mb-2">Eje X: Asignación total · Eje Y: % Cobranza · Tamaño: Cantidad de estudiantes</p>
            <div style="position: relative; height: 340px;">
              <canvas ref="chartBubble"></canvas>
            </div>
          </v-col>
          <v-col cols="12" md="7" class="mt-4">
            <div class="d-flex align-center justify-center mb-1">
              <h3>Pagos por Día</h3>
              <v-btn icon x-small class="ml-2" title="Exportar PNG" @click="exportarGrafico('chartDia', 'pagos-por-dia')">
                <v-icon small>mdi-download</v-icon>
              </v-btn>
            </div>
            <p class="text-center caption grey--text mb-2">Monto cobrado por fecha de registro del pago</p>
            <div style="position: relative; height: 300px;">
              <canvas ref="chartDia"></canvas>
            </div>
          </v-col>
          <v-col cols="12" md="5" class="mt-4">
            <div class="d-flex align-center justify-center mb-1">
              <h3>Pagos por Semana</h3>
              <v-btn icon x-small class="ml-2" title="Exportar PNG" @click="exportarGrafico('chartSemana', 'pagos-por-semana')">
                <v-icon small>mdi-download</v-icon>
              </v-btn>
            </div>
            <p class="text-center caption grey--text mb-2">Monto cobrado agrupado por semana (inicio: lunes)</p>
            <div style="position: relative; height: 300px;">
              <canvas ref="chartSemana"></canvas>
            </div>
          </v-col>
        </v-row>
      </v-card-text>

      <!-- Tabla Resumen Ejecutivo -->
      <v-card-text>
        <v-data-table
          :headers="headersEjecutivo"
          :items="resumenEjecutivo"
          :loading="loading || exporting"
          class="elevation-1"
          group-by="unidad_negocio"
          hide-default-footer
          :items-per-page="-1"
          fixed-header
          height="600"
          dense
        >
          <!-- Subtotales por Unidad de Negocio (alineados con columnas) -->
          <template v-slot:group.header="{ group, isOpen, toggle }">
            <td class="indigo lighten-5">
              <div class="d-flex align-center">
                <v-btn icon small @click="toggle">
                  <v-icon>{{ isOpen ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
                </v-btn>
                <strong class="indigo--text text--darken-3">
                  <v-icon small color="indigo darken-3" left>mdi-domain</v-icon>{{ group }}
                </strong>
              </div>
            </td>
           
            <td class="indigo lighten-5 text-center font-weight-bold">
              {{ totalesPorUnidad[group] ? totalesPorUnidad[group].cantidad_estudiantes : 0 }}
            </td>
            <td class="indigo lighten-5 text-center font-weight-bold">
              {{ totalesPorUnidad[group] ? totalesPorUnidad[group].cantidad_registros : 0 }}
            </td>
            <td class="indigo lighten-5"></td>
            <td v-if="modoDetallado" class="indigo lighten-5 text-right font-weight-bold">
              {{ formatMonto(totalesPorUnidad[group] ? totalesPorUnidad[group].asignacion_inicial : 0) }}
            </td>
            <td v-if="modoDetallado" class="indigo lighten-5 text-right font-weight-bold orange--text">
              {{ formatMonto(totalesPorUnidad[group] ? totalesPorUnidad[group].monto_revertido : 0) }}
            </td>
            <td v-if="modoDetallado" class="indigo lighten-5 text-right font-weight-bold cyan--text text--darken-2">
              {{ formatMonto(totalesPorUnidad[group] ? totalesPorUnidad[group].nuevo_plan : 0) }}
            </td>
            <td v-if="modoDetallado" class="indigo lighten-5 text-right font-weight-bold deep-orange--text">
              {{ formatMonto(totalesPorUnidad[group] ? totalesPorUnidad[group].monto_descuento : 0) }}
            </td>
            <td v-if="modoDetallado" class="indigo lighten-5 text-right font-weight-bold purple--text">
              {{ formatMonto(totalesPorUnidad[group] ? totalesPorUnidad[group].cambiado : 0) }}
            </td>
            <td class="indigo lighten-5 text-right font-weight-bold">
              {{ formatMonto(totalesPorUnidad[group] ? totalesPorUnidad[group].asignacion : 0) }}
            </td>
            <td class="indigo lighten-5 text-right font-weight-bold success--text">
              {{ formatMonto(totalesPorUnidad[group] ? totalesPorUnidad[group].monto_pagado : 0) }}
            </td>
            <td class="indigo lighten-5 text-right font-weight-bold"
              :class="totalesPorUnidad[group] && totalesPorUnidad[group].saldo > 0 ? 'error--text' : 'success--text'">
              {{ formatMonto(totalesPorUnidad[group] ? totalesPorUnidad[group].saldo : 0) }}
            </td>
            <td class="indigo lighten-5 text-right font-weight-bold light-green--text text--darken-2">
              {{ formatMonto(totalesPorUnidad[group] ? totalesPorUnidad[group].monto_adelantado : 0) }}
            </td>
            <td class="indigo lighten-5 text-center">
              <v-chip v-if="totalesPorUnidad[group]" :color="getColorPorcentaje(totalesPorUnidad[group].porcentaje)" dark x-small>
                {{ totalesPorUnidad[group].porcentaje.toFixed(2) }}%
              </v-chip>
            </td>
            <td class="indigo lighten-5"></td>
          </template>
          <template v-slot:item.asig_tipos="{ item }">
            <div class="d-flex flex-wrap" style="gap: 2px; max-width: 160px;">
              <v-chip v-for="t in item.asig_tipos" :key="t" :color="colorAsigTipo(t)" x-small dark>
                {{ t }}
              </v-chip>
            </div>
          </template>
          <template v-slot:item.asignacion_inicial="{ item }">
            <strong>{{ formatMonto(item.asignacion_inicial) }}</strong>
          </template>
          <template v-slot:item.nuevo_plan="{ item }">
            <span :class="item.nuevo_plan > 0 ? 'cyan--text text--darken-2 font-weight-bold' : ''">
              {{ formatMonto(item.nuevo_plan) }}
            </span>
          </template>
          <template v-slot:item.asignacion="{ item }">
            <strong>{{ formatMonto(item.asignacion) }}</strong>
          </template>
          <template v-slot:item.monto_revertido="{ item }">
            <span :class="item.monto_revertido > 0 ? 'orange--text font-weight-bold' : ''">
              {{ formatMonto(item.monto_revertido) }}
            </span>
          </template>
          <template v-slot:item.monto_descuento="{ item }">
            <span :class="item.monto_descuento > 0 ? 'deep-orange--text font-weight-bold' : ''">
              {{ formatMonto(item.monto_descuento) }}
            </span>
          </template>
          <template v-slot:item.cambiado="{ item }">
            <span :class="item.cambiado > 0 ? 'purple--text font-weight-bold' : ''">
              {{ formatMonto(item.cambiado) }}
            </span>
          </template>
          <template v-slot:item.monto_pagado="{ item }">
            <span class="success--text font-weight-bold">{{ formatMonto(item.monto_pagado) }}</span>
          </template>
          <template v-slot:item.saldo="{ item }">
            <strong :class="item.saldo > 0 ? 'error--text' : 'success--text'">
              {{ formatMonto(item.saldo) }}
            </strong>
          </template>
          <template v-slot:item.monto_adelantado="{ item }">
            <span :class="item.monto_adelantado > 0 ? 'light-green--text text--darken-2 font-weight-bold' : ''">
              {{ formatMonto(item.monto_adelantado) }}
            </span>
          </template>
          <template v-slot:item.porcentaje="{ item }">
            <div style="min-width: 90px;">
              <div :class="getColorPorcentaje(item.porcentaje) + '--text font-weight-bold caption'">
                {{ item.porcentaje.toFixed(1) }}%
              </div>
              <v-progress-linear
                :value="item.porcentaje"
                :color="getColorPorcentaje(item.porcentaje)"
                height="6"
                rounded
              ></v-progress-linear>
            </div>
          </template>
          <template v-slot:item.acciones="{ item }">
            <v-btn color="info" small @click="verDetalles(item)">
              Ver {{ item.cantidad_registros }} Registros
            </v-btn>
          </template>

          <!-- Fila de Totales Generales -->
          <template v-slot:body.append v-if="resumenEjecutivo.length > 0">
            <tr class="grey lighten-3 font-weight-bold">
              <td colspan="2" class="text-right">TOTAL GENERAL:</td>
              <td class="text-center">{{ totalesGenerales.cantidad_estudiantes }}</td>
              <td class="text-center">{{ totalesGenerales.cantidad_registros }}</td>
              <td></td>
              <td v-if="modoDetallado" class="text-right">{{ formatMonto(totalesGenerales.asignacion_inicial) }}</td>
              <td v-if="modoDetallado" class="text-right orange--text">{{ formatMonto(totalesGenerales.monto_revertido) }}</td>
              <td v-if="modoDetallado" class="text-right cyan--text text--darken-2">{{ formatMonto(totalesGenerales.nuevo_plan) }}</td>
              <td v-if="modoDetallado" class="text-right deep-orange--text">{{ formatMonto(totalesGenerales.monto_descuento) }}</td>
              <td v-if="modoDetallado" class="text-right purple--text">{{ formatMonto(totalesGenerales.cambiado) }}</td>
              <td class="text-right">{{ formatMonto(totalesGenerales.asignacion) }}</td>
              <td class="text-right">{{ formatMonto(totalesGenerales.monto_pagado) }}</td>
              <td class="text-right">{{ formatMonto(totalesGenerales.saldo) }}</td>
              <td class="text-right">{{ formatMonto(totalesGenerales.monto_adelantado) }}</td>
              <td class="text-center">
                <v-chip :color="getColorPorcentaje(totalesGenerales.porcentaje)" dark small>
                  {{ totalesGenerales.porcentaje.toFixed(2) }}%
                </v-chip>
              </td>
              <td></td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- Dialog para ver detalles de la sede seleccionada -->
    <v-dialog v-model="dialogDetalles" max-width="1200px">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Detalles: {{ seleccion.unidad }} - {{ seleccion.sede }}
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogDetalles = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-data-table
            :headers="headersDetalle"
            :items="registrosSeleccionados"
            class="elevation-1"
          >
            <template v-slot:item.plan_pago_monto="{ item }">
              Bs {{ formatMonto(parseFloat(item.plan_pago_monto) || 0) }}
            </template>
            <template v-slot:item.pago_monto="{ item }">
              Bs {{ formatMonto(parseFloat(item.pago_monto) || 0) }}
            </template>
            <template v-slot:item.encargado_cobranza="{ item }">
              <div v-if="item.encargado_cobranza" class="d-flex align-center">
                <v-avatar size="28" color="deep-purple" class="mr-2">
                  <span class="white--text text-caption">{{ getIniciales(item.encargado_cobranza) }}</span>
                </v-avatar>
                <span class="caption">{{ item.encargado_cobranza }}</span>
              </div>
              <span v-else class="grey--text">Sin asignar</span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar para notificaciones -->
    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="4000" top>
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">Cerrar</v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import xaxios from '@/xaxios';
import Chart from 'chart.js';
import * as XLSX from 'xlsx';
import asignacionFormatos from '@/mixins/asignacionFormatos';

const hoy = new Date();
const primerDiaMes = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
const toISODate = (d) => new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);

export default {
  name: 'AsignacionesEjecutivoV8',
  mixins: [asignacionFormatos],
  data() {
    return {
      loading: false,
      exporting: false,
      exportandoPDF: false,
      chartInstance: null,
      chartInstanceDoughnut: null,
      chartInstancePorcentaje: null,
      chartInstanceStacked: null,
      chartInstanceBubble: null,
      chartInstanceDia: null,
      chartInstanceSemana: null,
      unidadSeleccionada: null,
      filtros: {
        fecha_inicio_mes: toISODate(primerDiaMes),
        fecha_consulta: toISODate(hoy),
      },
      busqueda: '',
      filtroEstado: [],
      filtroAsignacion: [],
      filtroTipoPlan: [],
      filtroUnidad: [],
      filtroSede: [],
      filtroConceptos: [],
      modoDetallado: false,
      records: [],
      dialogDetalles: false,
      seleccion: {
        unidad: '',
        sede: ''
      },
      registrosSeleccionados: [],
      headersDetalle: [
        { text: 'Estudiante', value: 'est_nombres' },
        { text: 'Apellidos', value: 'est_apellidos' },
        { text: 'Programa', value: 'prog_codigo' },
        { text: 'Tipo Registro', value: 'tipo_registro' },
        { text: 'Estado Asig.', value: 'asig_estado' },
        { text: 'Cuota', value: 'plan_pago_cuota' },
        { text: 'Esperado', value: 'plan_pago_monto' },
        { text: 'Pagado', value: 'pago_monto' },
        { text: 'Encargado Cobranza', value: 'encargado_cobranza' },
      ],
    };
  },
  computed: {
    headersEjecutivo() {
      const cols = [
        { text: 'Unidad de Negocio', value: 'unidad_negocio' },
        { text: 'Sede', value: 'sede' },
        { text: 'Estudiantes', value: 'cantidad_estudiantes', align: 'center' },
        { text: 'Registros', value: 'cantidad_registros', align: 'center' },
        { text: 'Tipo Asig.', value: 'asig_tipos', sortable: false },
      ];
      if (this.modoDetallado) {
        cols.push(
          { text: 'Asign. Inicial (Bs)', value: 'asignacion_inicial', align: 'right' },
          { text: 'Revertido (Bs)', value: 'monto_revertido', align: 'right' },
          { text: 'Nuevos Planes (Bs)', value: 'nuevo_plan', align: 'right' },
          { text: 'Descuentos (Bs)', value: 'monto_descuento', align: 'right' },
          { text: 'Cambios Fechas (Bs)', value: 'cambiado', align: 'right' },
        );
      }
      cols.push(
        { text: 'Asignación (Bs)', value: 'asignacion', align: 'right' },
        { text: 'Pagados (Bs)', value: 'monto_pagado', align: 'right' },
        { text: 'Saldo (Bs)', value: 'saldo', align: 'right' },
        { text: 'Adelantado (Bs)', value: 'monto_adelantado', align: 'right' },
        { text: '% Cobranza', value: 'porcentaje', align: 'center' },
        { text: 'Acciones', value: 'acciones', sortable: false, align: 'center' },
      );
      return cols;
    },
    opcionesEstado() { return this.opcionesUnicas('asig_estado'); },
    opcionesAsignacion() { return this.opcionesUnicas('asig_tipo'); },
    tiposAsignacionChips() {
      return this.opcionesAsignacion.filter(o => o.value !== 'todos');
    },
    sedesChips() {
      return this.opcionesSede.filter(o => o.value !== 'todos');
    },
    opcionesTipoPlan() { return this.opcionesUnicas('ins_tipo_plan'); },
    opcionesUnidad() { return this.opcionesUnicas('prog_unidad_negocio'); },
    opcionesSede() { return this.opcionesUnicas('prog_sede_esam'); },
    opcionesConcepto() {
      const map = new Map();
      this.records.forEach(item => {
        const id = this.getConceptoId(item);
        const nombre = this.getConceptoNombre(item);
        if (id != null && nombre) map.set(id, nombre);
      });
      return Array.from(map, ([value, text]) => ({ value, text })).sort((a, b) => a.text.localeCompare(b.text));
    },
    datosFiltrados() {
      const q = this.busqueda ? this.busqueda.toLowerCase() : null;
      const conceptos = this.filtroConceptos.length > 0 ? this.filtroConceptos : null;
      return this.records.filter(i => {
        if (this.filtroAsignacion.length && !this.filtroAsignacion.includes(i.asig_tipo)) return false;
        if (this.filtroEstado.length     && !this.filtroEstado.includes(i.asig_estado))   return false;
        if (this.filtroTipoPlan.length   && !this.filtroTipoPlan.includes(i.ins_tipo_plan)) return false;
        if (this.filtroUnidad.length     && !this.filtroUnidad.includes(i.prog_unidad_negocio)) return false;
        if (this.filtroSede.length       && !this.filtroSede.includes(i.prog_sede_esam))   return false;
        if (conceptos && !conceptos.includes(this.getConceptoId(i))) return false;
        if (q && ![i.est_nombres, i.est_apellidos, i.est_num_doc, i.est_correo,
                    i.prog_codigo, i.prog_nombre_compuesto]
            .some(v => String(v || '').toLowerCase().includes(q))) return false;
        return true;
      });
    },
    totalesPorUnidad() {
      const map = {};
      this.resumenEjecutivo.forEach(item => {
        if (!map[item.unidad_negocio]) {
          map[item.unidad_negocio] = {
            estudiantesSet: new Set(),
            cantidad_registros: 0,
            asignacion_inicial: 0,
            nuevo_plan: 0,
            monto_revertido: 0,
            monto_descuento: 0,
            cambiado: 0,
            asignacion: 0,
            monto_pagado: 0,
            monto_adelantado: 0,
          };
        }
        const u = map[item.unidad_negocio];
        u.cantidad_registros += item.cantidad_registros;
        u.asignacion_inicial += item.asignacion_inicial;
        u.nuevo_plan += item.nuevo_plan;
        u.monto_revertido += item.monto_revertido;
        u.monto_descuento += item.monto_descuento;
        u.cambiado += item.cambiado;
        u.asignacion += item.asignacion;
        u.monto_pagado += item.monto_pagado;
        u.monto_adelantado += item.monto_adelantado;
      });
      this.datosFiltrados.forEach(i => {
        const unidad = i.prog_unidad_negocio || 'Sin Unidad';
        if (map[unidad] && i.est_num_doc) map[unidad].estudiantesSet.add(i.est_num_doc);
      });
      Object.keys(map).forEach(k => {
        const u = map[k];
        u.cantidad_estudiantes = u.estudiantesSet.size;
        delete u.estudiantesSet;
        u.saldo = u.asignacion - u.monto_pagado;
        u.porcentaje = u.asignacion > 0 ? (u.monto_pagado / u.asignacion) * 100 : 0;
      });
      return map;
    },
    resumenEjecutivo() {
      const agrupado = {};

      this.datosFiltrados.forEach((item) => {
        const unidad = item.prog_unidad_negocio || 'Sin Unidad';
        const sede = item.prog_sede_esam || 'Sin Sede';
        const key = `${unidad}|${sede}`;

        if (!agrupado[key]) {
          agrupado[key] = {
            unidad_negocio: unidad,
            sede: sede,
            cantidad_registros: 0,
            estudiantes: new Set(),
            asig_tipos_set: new Set(),
            asignacion_inicial: 0,
            nuevo_plan: 0,
            monto_revertido: 0,
            monto_descuento: 0,
            cambiado: 0,
            monto_pagado: 0,
            monto_adelantado: 0,
            registros: [],
          };
        }
        const g = agrupado[key];
        g.cantidad_registros += 1;
        g.registros.push(item);
        if (item.est_num_doc) g.estudiantes.add(item.est_num_doc);
        if (item.asig_tipo) g.asig_tipos_set.add(item.asig_tipo);

        const tipo = String(item.tipo_registro || '').trim().toLowerCase();

        if (tipo === 'nuevo') {
          g.nuevo_plan += parseFloat(item.plan_pago_monto) || 0;
        } else if (tipo === 'dw') {
          g.asignacion_inicial += parseFloat(item.plan_pago_monto_saldo_inicio) || 0;
          if (item.plan_modificado == 1) {
            g.cambiado += parseFloat(item.plan_pago_monto_saldo_inicio) || 0;
          }
        } else if (tipo === 'descuento_revertido') {
          g.monto_revertido += parseFloat(item.descuento_monto_revertido) || 0;
        } else if (tipo === 'descuento_aprobado') {
          g.monto_descuento += parseFloat(item.descuento_monto_revertido) || 0;
        } else if (tipo === 'pagado') {
          const monto = parseFloat(item.pago_monto) || 0;
          if (item.asig_estado === 'adelantado') {
            g.monto_adelantado += monto;
          } else {
            g.monto_pagado += monto;
          }
        }
      });

      return Object.values(agrupado).map(g => {
        const asignacion = g.asignacion_inicial + g.nuevo_plan + g.monto_revertido - g.monto_descuento - g.cambiado;
        return {
          unidad_negocio:       g.unidad_negocio,
          sede:                 g.sede,
          cantidad_registros:   g.cantidad_registros,
          cantidad_estudiantes: g.estudiantes.size,
          asig_tipos:           Array.from(g.asig_tipos_set).sort(),
          asignacion_inicial:   g.asignacion_inicial,
          nuevo_plan:           g.nuevo_plan,
          monto_revertido:      g.monto_revertido,
          monto_descuento:      g.monto_descuento,
          cambiado:             g.cambiado,
          monto_pagado:         g.monto_pagado,
          monto_adelantado:     g.monto_adelantado,
          registros:            Object.freeze(g.registros),
          asignacion,
          saldo:      asignacion - g.monto_pagado,
          porcentaje: asignacion > 0 ? (g.monto_pagado / asignacion) * 100 : 0,
        };
      }).sort((a, b) => b.asignacion - a.asignacion);
    },
    claveGrafico() {
      return this.unidadSeleccionada ? 'sede' : 'unidad_negocio';
    },
    resumenParaGraficos() {
      if (!this.unidadSeleccionada) return this.resumenEjecutivo;
      return this.resumenEjecutivo.filter(g => g.unidad_negocio === this.unidadSeleccionada);
    },
    datosGraficoUnidadNegocio() {
      const clave = this.claveGrafico;
      const agrupado = {};
      this.resumenParaGraficos.forEach((grupo) => {
        if (!agrupado[grupo[clave]]) {
          agrupado[grupo[clave]] = { asignacion: 0, monto_pagado: 0, saldo: 0, estudiantes: 0 };
        }
        agrupado[grupo[clave]].asignacion   += grupo.asignacion;
        agrupado[grupo[clave]].monto_pagado += grupo.monto_pagado;
        agrupado[grupo[clave]].saldo        += grupo.saldo;
        agrupado[grupo[clave]].estudiantes  += grupo.cantidad_estudiantes;
      });
      const labels = Object.keys(agrupado);
      return {
        labels,
        asignacion:   labels.map(l => agrupado[l].asignacion),
        monto_pagado: labels.map(l => agrupado[l].monto_pagado),
        saldo:        labels.map(l => agrupado[l].saldo),
        estudiantes:  labels.map(l => agrupado[l].estudiantes),
        porcentaje:   labels.map(l => {
          const a = agrupado[l].asignacion;
          return a > 0 ? parseFloat(((agrupado[l].monto_pagado / a) * 100).toFixed(1)) : 0;
        }),
      };
    },
    _pagosFiltrados() {
      const source = this.unidadSeleccionada
        ? this.datosFiltrados.filter(i => (i.prog_unidad_negocio || 'Sin Unidad') === this.unidadSeleccionada)
        : this.datosFiltrados;
      return source.filter(i => i.tipo_registro === 'pagado' && i.pago_fecha_registro);
    },
    datosGraficoPorDia() {
      const dias = {};
      this._pagosFiltrados.forEach(i => {
        const key = String(i.pago_fecha_registro).slice(0, 10);
        if (!dias[key]) dias[key] = { monto: 0, cantidad: 0 };
        dias[key].monto    += parseFloat(i.pago_monto) || 0;
        dias[key].cantidad += 1;
      });
      const keys = Object.keys(dias).sort();
      return {
        labels:   keys.map(k => { const [, m, d] = k.split('-'); return `${d}/${m}`; }),
        monto:    keys.map(k => parseFloat(dias[k].monto.toFixed(2))),
        cantidad: keys.map(k => dias[k].cantidad),
      };
    },
    datosGraficoPorSemana() {
      const semanas = {};
      this._pagosFiltrados.forEach(i => {
        const fecha = new Date(i.pago_fecha_registro);
        const dia   = fecha.getDay();
        const lunes = new Date(fecha);
        lunes.setDate(fecha.getDate() - (dia === 0 ? 6 : dia - 1));
        const key = `${lunes.getFullYear()}-${String(lunes.getMonth()+1).padStart(2,'0')}-${String(lunes.getDate()).padStart(2,'0')}`;
        if (!semanas[key]) semanas[key] = { monto: 0, cantidad: 0 };
        semanas[key].monto    += parseFloat(i.pago_monto) || 0;
        semanas[key].cantidad += 1;
      });
      const keys = Object.keys(semanas).sort();
      return {
        labels:   keys.map(k => { const [, m, d] = k.split('-'); return `Sem ${d}/${m}`; }),
        monto:    keys.map(k => parseFloat(semanas[k].monto.toFixed(2))),
        cantidad: keys.map(k => semanas[k].cantidad),
      };
    },
    datosGraficoBubble() {
      const clave = this.claveGrafico;
      const agrupado = {};
      this.resumenParaGraficos.forEach(g => {
        const key = g[clave];
        if (!agrupado[key]) agrupado[key] = { asignacion: 0, monto_pagado: 0, estudiantes: 0 };
        agrupado[key].asignacion   += g.asignacion;
        agrupado[key].monto_pagado += g.monto_pagado;
        agrupado[key].estudiantes  += g.cantidad_estudiantes;
      });

      const entries = Object.entries(agrupado).map(([label, v]) => ({
        label,
        asignacion:  v.asignacion,
        porcentaje:  v.asignacion > 0 ? (v.monto_pagado / v.asignacion) * 100 : 0,
        estudiantes: v.estudiantes,
      }));

      const maxEst = Math.max(...entries.map(e => e.estudiantes), 1);
      const MIN_R = 8, MAX_R = 30;

      return entries.map(e => ({
        label:      e.label,
        x:          parseFloat(e.asignacion.toFixed(2)),
        y:          parseFloat(e.porcentaje.toFixed(2)),
        r:          Math.round(MIN_R + ((e.estudiantes / maxEst) * (MAX_R - MIN_R))),
        estudiantes: e.estudiantes,
        color:      e.porcentaje >= 80 ? 'rgba(56,142,60,0.75)' :
                    e.porcentaje >= 50 ? 'rgba(251,140,0,0.75)' :
                                         'rgba(229,57,53,0.75)',
        border:     e.porcentaje >= 80 ? '#2e7d32' :
                    e.porcentaje >= 50 ? '#e65100' :
                                         '#b71c1c',
      }));
    },
    datosGraficoStacked() {
      const clave = this.claveGrafico;
      const agrupado = {};
      this.resumenParaGraficos.forEach(g => {
        const key = g[clave];
        if (!agrupado[key]) agrupado[key] = { monto_pagado: 0, saldo: 0, monto_adelantado: 0 };
        agrupado[key].monto_pagado    += g.monto_pagado;
        agrupado[key].saldo           += g.saldo;
        agrupado[key].monto_adelantado += g.monto_adelantado;
      });
      const labels = Object.keys(agrupado);
      return {
        labels,
        monto_pagado:    labels.map(l => agrupado[l].monto_pagado),
        saldo:           labels.map(l => agrupado[l].saldo),
        monto_adelantado: labels.map(l => agrupado[l].monto_adelantado),
      };
    },
    datosGraficoPorcentaje() {
      const clave = this.claveGrafico;
      const agrupado = {};
      this.resumenParaGraficos.forEach(g => {
        const key = g[clave];
        if (!agrupado[key]) agrupado[key] = { asignacion: 0, monto_pagado: 0 };
        agrupado[key].asignacion   += g.asignacion;
        agrupado[key].monto_pagado += g.monto_pagado;
      });
      const entries = Object.entries(agrupado)
        .map(([label, v]) => ({
          label,
          porcentaje: v.asignacion > 0 ? parseFloat(((v.monto_pagado / v.asignacion) * 100).toFixed(2)) : 0,
        }))
        .sort((a, b) => b.porcentaje - a.porcentaje);
      return {
        labels:     entries.map(e => e.label),
        porcentaje: entries.map(e => e.porcentaje),
        colores:    entries.map(e =>
          e.porcentaje >= 80 ? 'rgba(56,142,60,0.8)' :
          e.porcentaje >= 50 ? 'rgba(251,140,0,0.8)' :
                               'rgba(229,57,53,0.8)'
        ),
      };
    },
    totalesGenerales() {
      const t = {
        cantidad_registros: 0,
        cantidad_estudiantes: 0,
        asignacion_inicial: 0,
        nuevo_plan: 0,
        monto_revertido: 0,
        monto_descuento: 0,
        cambiado: 0,
        asignacion: 0,
        monto_pagado: 0,
        monto_adelantado: 0,
      };
      const estudiantesGlobal = new Set();

      this.resumenEjecutivo.forEach((item) => {
        t.cantidad_registros += item.cantidad_registros;
        t.asignacion_inicial += item.asignacion_inicial;
        t.nuevo_plan += item.nuevo_plan;
        t.monto_revertido += item.monto_revertido;
        t.monto_descuento += item.monto_descuento;
        t.cambiado += item.cambiado;
        t.asignacion += item.asignacion;
        t.monto_pagado += item.monto_pagado;
        t.monto_adelantado += item.monto_adelantado;
      });
      this.datosFiltrados.forEach(i => { if (i.est_num_doc) estudiantesGlobal.add(i.est_num_doc); });
      t.cantidad_estudiantes = estudiantesGlobal.size;

      return {
        ...t,
        saldo: t.asignacion - t.monto_pagado,
        porcentaje: t.asignacion > 0 ? (t.monto_pagado / t.asignacion) * 100 : 0,
      };
    },
  },
  watch: {
    resumenEjecutivo() {
      this.$nextTick(() => this.renderChart());
    },
    unidadSeleccionada() {
      this.$nextTick(() => this.renderChart());
    },
  },
  methods: {
    async fetchData() {
      if (this.filtros.fecha_inicio_mes > this.filtros.fecha_consulta) {
        this.mostrarNotificacion('La fecha de inicio no puede ser mayor a la fecha de consulta.', 'error');
        return;
      }
      this.loading = true;
      try {
        const response = await xaxios.get(`${process.env.VUE_APP_API_REST}/api/v8/esam/asignacion/programas`, {
          params: {
            fecha_inicio_mes: this.filtros.fecha_inicio_mes,
            fecha_consulta: this.filtros.fecha_consulta,
          },
        });

        this.records = response.data.data || [];
        if (this.records.length === 0) {
          this.mostrarNotificacion('No se encontraron registros para el rango seleccionado.', 'info');
        }
      } catch (error) {
        const detalle = error?.response?.data?.message || error?.response?.data?.error || error?.message || '';
        const texto = detalle ? `Error al obtener los registros: ${detalle}` : 'Error al obtener los registros';
        this.mostrarNotificacion(texto, 'error');
        window.console.error('Error al obtener datos V8 Ejecutivo:', error);
      } finally {
        this.loading = false;
      }
    },
    verDetalles(item) {
      this.seleccion.unidad = item.unidad_negocio;
      this.seleccion.sede = item.sede;
      this.registrosSeleccionados = [...item.registros];
      this.dialogDetalles = true;
    },
    getColorPorcentaje(porcentaje) {
      const val = parseFloat(porcentaje);
      if (val >= 80) return 'green';
      if (val >= 50) return 'orange';
      return 'red';
    },
    colorAsigTipo(tipo) {
      const t = String(tipo || '').toLowerCase();
      if (t.includes('cobranza') || t.includes('cartera')) return 'red darken-2';
      if (t.includes('marketing') || t.includes('nuevos') || t.includes('inscritos')) return 'green darken-2';
      return 'blue-grey';
    },
    opcionesUnicas(campo) {
      const valores = new Set(this.records.map(item => item[campo]).filter(Boolean));
      return Array.from(valores).sort().map(value => ({ text: value, value }));
    },
    getConceptoId(item) {
      return item.plan_pago_concepto || null;
    },
    getConceptoNombre(item) {
      return item.plan_pago_concepto || '';
    },
    exportarGrafico(refName, nombre) {
      const canvas = this.$refs[refName];
      if (!canvas) return;
      const link = document.createElement('a');
      link.download = `${nombre}.png`;
      link.href = canvas.toDataURL('image/png');
      link.click();
    },
    limpiarFiltros() {
      this.busqueda = '';
      this.filtroEstado = [];
      this.filtroAsignacion = [];
      this.filtroTipoPlan = [];
      this.filtroUnidad = [];
      this.filtroSede = [];
      this.filtroConceptos = [];
    },
    exportarPDF() {
      if (!this.resumenEjecutivo.length) return;
      this.exportandoPDF = true;

      const fmt = (v) => this.formatMonto(v);
      const detallado = this.modoDetallado;

      const th = (t, pct) => `<th style="background:#283593;color:white;padding:4px 6px;text-align:center;font-size:10px;border:1px solid #1a237e;width:${pct}%">${t}</th>`;
      const td = (t, right = false) => `<td style="padding:3px 5px;border:1px solid #ddd;font-size:10px${right ? ';text-align:right' : ''}">${t}</td>`;
      const tdBold = (t) => `<td style="padding:3px 5px;border:1px solid #ddd;font-size:10px;color:#1a237e;font-weight:bold">${t}</td>`;

      // Porcentajes por columna, deben sumar 100
      const cols = detallado ? [
        { h: 'Unidad de Negocio', pct: 10 }, { h: 'Sede', pct: 13 },
        { h: 'Est.', pct: 3 },  { h: 'Reg.', pct: 3 }, { h: 'Tipo Asig.', pct: 11 },
        { h: 'Asign. Inicial', pct: 5 }, { h: 'Revertido', pct: 5 },
        { h: 'Nuevos Planes', pct: 5 }, { h: 'Descuentos', pct: 5 }, { h: 'Cambios Fechas', pct: 5 },
        { h: 'Asignación', pct: 7 }, { h: 'Pagados', pct: 7 },
        { h: 'Saldo', pct: 7 }, { h: 'Adelantado', pct: 7 }, { h: '% Cobranza', pct: 7 },
      ] : [
        { h: 'Unidad de Negocio', pct: 13 }, { h: 'Sede', pct: 17 },
        { h: 'Est.', pct: 4 }, { h: 'Reg.', pct: 4 }, { h: 'Tipo Asig.', pct: 18 },
        { h: 'Asignación', pct: 10 }, { h: 'Pagados', pct: 10 },
        { h: 'Saldo', pct: 10 }, { h: 'Adelantado', pct: 10 }, { h: '% Cobranza', pct: 4 },
      ];

      const porUnidad = {};
      this.resumenEjecutivo.forEach((item) => {
        if (!porUnidad[item.unidad_negocio]) porUnidad[item.unidad_negocio] = [];
        porUnidad[item.unidad_negocio].push(item);
      });

      let rows = '';
      Object.entries(porUnidad).forEach(([unidad, items]) => {
        const tu = this.totalesPorUnidad[unidad] || {};
        let gr = `<tr style="background:#e8eaf6;font-weight:bold">`;
        gr += tdBold(unidad);
        gr += td(''); // Sede vacío
        gr += td(tu.cantidad_estudiantes || 0, true);
        gr += td(tu.cantidad_registros || 0, true);
        gr += td(''); // Tipo vacío
        if (detallado) {
          gr += td(fmt(tu.asignacion_inicial || 0), true);
          gr += td(fmt(tu.monto_revertido || 0), true);
          gr += td(fmt(tu.nuevo_plan || 0), true);
          gr += td(fmt(tu.monto_descuento || 0), true);
          gr += td(fmt(tu.cambiado || 0), true);
        }
        gr += td(fmt(tu.asignacion || 0), true);
        gr += td(fmt(tu.monto_pagado || 0), true);
        gr += td(fmt(tu.saldo || 0), true);
        gr += td(fmt(tu.monto_adelantado || 0), true);
        gr += td(tu.porcentaje != null ? tu.porcentaje.toFixed(2) + '%' : '', true);
        gr += '</tr>';
        rows += gr;

        items.forEach((item) => {
          let row = '<tr>';
          row += td(''); // Unidad vacío
          row += td(item.sede);
          row += td(item.cantidad_estudiantes, true);
          row += td(item.cantidad_registros, true);
          row += td(item.asig_tipos.join(', '));
          if (detallado) {
            row += td(fmt(item.asignacion_inicial), true);
            row += td(fmt(item.monto_revertido), true);
            row += td(fmt(item.nuevo_plan), true);
            row += td(fmt(item.monto_descuento), true);
            row += td(fmt(item.cambiado), true);
          }
          row += td(fmt(item.asignacion), true);
          row += td(fmt(item.monto_pagado), true);
          row += td(fmt(item.saldo), true);
          row += td(fmt(item.monto_adelantado), true);
          row += td(item.porcentaje.toFixed(2) + '%', true);
          row += '</tr>';
          rows += row;
        });
      });

      const tg = this.totalesGenerales;
      let total = `<tr style="background:#f5f5f5;font-weight:bold">`;
      total += `<td colspan="2" style="padding:3px 5px;border:1px solid #ddd;font-size:10px;font-weight:bold">TOTAL GENERAL</td>`;
      total += td(tg.cantidad_estudiantes, true);
      total += td(tg.cantidad_registros, true);
      total += td('');
      if (detallado) {
        total += td(fmt(tg.asignacion_inicial), true);
        total += td(fmt(tg.monto_revertido), true);
        total += td(fmt(tg.nuevo_plan), true);
        total += td(fmt(tg.monto_descuento), true);
        total += td(fmt(tg.cambiado), true);
      }
      total += td(fmt(tg.asignacion), true);
      total += td(fmt(tg.monto_pagado), true);
      total += td(fmt(tg.saldo), true);
      total += td(fmt(tg.monto_adelantado), true);
      total += td(tg.porcentaje.toFixed(2) + '%', true);
      total += '</tr>';
      rows += total;

      const html = `
        <div style="padding:8px;font-family:Arial,sans-serif">
          <h3 style="text-align:center;margin-bottom:4px;font-size:13px">Asignaciones V8 - Resumen Ejecutivo</h3>
          <p style="text-align:center;font-size:10px;margin:0 0 6px;color:#555">
            Período: ${this.filtros.fecha_inicio_mes} al ${this.filtros.fecha_consulta}
          </p>
          <table style="width:100%;border-collapse:collapse;table-layout:fixed">
            <thead><tr>${cols.map((c) => th(c.h, c.pct)).join('')}</tr></thead>
            <tbody>${rows}</tbody>
          </table>
        </div>`;

      const el = document.createElement('div');
      el.innerHTML = html;
      document.body.appendChild(el);

      window.html2pdf()
        .set({
          margin: 0.3,
          filename: 'resumen-ejecutivo-v8.pdf',
          image: { type: 'jpeg', quality: 0.95 },
          html2canvas: { scale: 2, useCORS: true },
          jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' },
        })
        .from(el)
        .save()
        .then(() => {
          document.body.removeChild(el);
          this.exportandoPDF = false;
        })
        .catch((e) => {
          document.body.removeChild(el);
          window.console.error(e);
          this.exportandoPDF = false;
        });
    },
    exportarExcel() {
      if (!this.resumenEjecutivo.length) return;
      
      this.exporting = true;

      this.$nextTick(() => {
        try {
          const detalladoCols = this.modoDetallado
            ? ['Asign. Inicial', 'Revertido', 'Nuevos Planes', 'Descuentos', 'Cambios Fechas']
            : [];
          const headers = ['Unidad de Negocio', 'Sede', 'Estudiantes', 'Registros', 'Tipo Asig.',
            ...detalladoCols, 'Asignación', 'Pagados', 'Saldo', 'Adelantado', '% Cobranza'];

          const extraNums = item => this.modoDetallado
            ? [item.asignacion_inicial, item.monto_revertido, item.nuevo_plan, item.monto_descuento, item.cambiado]
            : [];

          const rows = this.resumenEjecutivo.map(item => [
            item.unidad_negocio,
            item.sede,
            item.cantidad_estudiantes,
            item.cantidad_registros,
            item.asig_tipos.join(', '),
            ...extraNums(item),
            item.asignacion,
            item.monto_pagado,
            item.saldo,
            item.monto_adelantado,
            parseFloat(item.porcentaje.toFixed(2)),
          ]);

          const tg = this.totalesGenerales;
          rows.push([
            'TOTAL GENERAL', '',
            tg.cantidad_estudiantes,
            tg.cantidad_registros,
            '',
            ...extraNums(tg),
            tg.asignacion,
            tg.monto_pagado,
            tg.saldo,
            tg.monto_adelantado,
            parseFloat(tg.porcentaje.toFixed(2)),
          ]);

          const aoa = [headers, ...rows];
          const ws = XLSX.utils.aoa_to_sheet(aoa);
          ws['!cols'] = headers.map((h, i) => {
            const maxLen = rows.reduce((m, r) => Math.max(m, String(r[i] ?? '').length), String(h).length);
            return { wch: Math.min(maxLen + 2, 50) };
          });
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, 'Resumen Ejecutivo');
          XLSX.writeFile(wb, 'Resumen_Ejecutivo_V8.xlsx');
        } catch (error) {
          this.mostrarNotificacion('Error al exportar a Excel.', 'error');
          window.console.error('Error exportando excel:', error);
        } finally {
          this.exporting = false;
        }
      });
    },
    renderChart() {
      if (this.chartInstance) {
        this.chartInstance.destroy();
        this.chartInstance = null;
      }
      const ctx = this.$refs.chartUnidadNegocio;
      if (!ctx) return;

      const d = this.datosGraficoUnidadNegocio;
      const fmt = v => Number(v).toLocaleString('es-BO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

      this.chartInstance = new Chart(ctx.getContext('2d'), {
        type: 'bar',
        data: {
          labels: d.labels,
          datasets: [
            {
              label: 'Asignación (Bs)',
              data: d.asignacion,
              backgroundColor: 'rgba(25, 118, 210, 0.75)',
              borderColor: '#1565c0',
              borderWidth: 1,
            },
            {
              label: 'Pagado (Bs)',
              data: d.monto_pagado,
              backgroundColor: 'rgba(56, 142, 60, 0.75)',
              borderColor: '#2e7d32',
              borderWidth: 1,
            },
            {
              label: 'Saldo (Bs)',
              data: d.saldo,
              backgroundColor: 'rgba(229, 57, 53, 0.75)',
              borderColor: '#b71c1c',
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { position: 'top' },
          onClick: (event, elements) => {
            if (!elements.length || this.unidadSeleccionada) return;
            this.unidadSeleccionada = d.labels[elements[0]._index];
          },
          onHover: (event, elements) => {
            event.target.style.cursor = elements.length && !this.unidadSeleccionada ? 'pointer' : 'default';
          },
          scales: {
            xAxes: [{ gridLines: { display: false } }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
                callback: v => Number(v).toLocaleString('es-BO', { maximumFractionDigits: 0 }),
              },
            }],
          },
          tooltips: {
            mode: 'index',
            callbacks: {
              label: (item, data) => {
                const ds = data.datasets[item.datasetIndex];
                return `${ds.label}: ${fmt(item.yLabel)} Bs.`;
              },
              afterBody: (items) => {
                const idx = items[0].index;
                return [
                  `Estudiantes: ${d.estudiantes[idx]}`,
                  `% Cobranza: ${d.porcentaje[idx]}%`,
                ];
              },
            },
          },
        },
      });
      this.renderChartDoughnut();
      this.renderChartPorcentaje();
      this.renderChartStacked();
      this.renderChartBubble();
      this.renderChartPorDia();
      this.renderChartPorSemana();
    },
    renderChartDoughnut() {
      if (this.chartInstanceDoughnut) {
        this.chartInstanceDoughnut.destroy();
        this.chartInstanceDoughnut = null;
      }
      const ctx = this.$refs.chartDoughnut;
      if (!ctx) return;

      const d = this.datosGraficoUnidadNegocio;
      const fmt = v => Number(v).toLocaleString('es-BO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const colors = ['#1976d2', '#388e3c', '#f57c00', '#e53935', '#8e24aa', '#00acc1', '#fb8c00', '#43a047'];

      this.chartInstanceDoughnut = new Chart(ctx.getContext('2d'), {
        type: 'doughnut',
        data: {
          labels: d.labels,
          datasets: [{
            data: d.monto_pagado,
            backgroundColor: colors.slice(0, d.labels.length),
            borderWidth: 1,
          }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { position: 'bottom' },
          onClick: (event, elements) => {
            if (!elements.length || this.unidadSeleccionada) return;
            this.unidadSeleccionada = d.labels[elements[0]._index];
          },
          onHover: (event, elements) => {
            event.target.style.cursor = elements.length && !this.unidadSeleccionada ? 'pointer' : 'default';
          },
          tooltips: {
            callbacks: {
              label: (item, data) => {
                const label = data.labels[item.index] || '';
                const value = data.datasets[0].data[item.index];
                return `${label}: ${fmt(value)} Bs.`;
              },
            },
          },
        },
      });
    },
    _renderChartPagos(refName, instanceKey, d) {
      if (this[instanceKey]) {
        this[instanceKey].destroy();
        this[instanceKey] = null;
      }
      const ctx = this.$refs[refName];
      if (!ctx || !d.labels.length) return;

      const fmt = v => Number(v).toLocaleString('es-BO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

      this[instanceKey] = new Chart(ctx.getContext('2d'), {
        type: 'bar',
        data: {
          labels: d.labels,
          datasets: [{
            label: 'Monto cobrado (Bs)',
            data: d.monto,
            backgroundColor: d.monto.map(v => {
              const max = Math.max(...d.monto);
              const ratio = max > 0 ? v / max : 0;
              if (ratio >= 0.75) return 'rgba(27,94,32,0.85)';
              if (ratio >= 0.4)  return 'rgba(56,142,60,0.75)';
              return 'rgba(165,214,167,0.85)';
            }),
            borderWidth: 0,
          }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { display: false },
          title: { display: false },
          scales: {
            xAxes: [{ gridLines: { display: false }, ticks: { maxRotation: 45, minRotation: 30 } }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
                callback: v => Number(v).toLocaleString('es-BO', { maximumFractionDigits: 0 }),
              },
            }],
          },
          tooltips: {
            callbacks: {
              label: (item) => ` ${fmt(item.yLabel)} Bs.`,
              afterLabel: (item) => {
                const idx = item.index;
                return ` ${d.cantidad[idx]} pago${d.cantidad[idx] !== 1 ? 's' : ''}`;
              },
            },
          },
        },
      });
    },
    renderChartPorDia() {
      this._renderChartPagos('chartDia', 'chartInstanceDia', this.datosGraficoPorDia);
    },
    renderChartPorSemana() {
      this._renderChartPagos('chartSemana', 'chartInstanceSemana', this.datosGraficoPorSemana);
    },
    renderChartBubble() {
      if (this.chartInstanceBubble) {
        this.chartInstanceBubble.destroy();
        this.chartInstanceBubble = null;
      }
      const ctx = this.$refs.chartBubble;
      if (!ctx) return;

      const puntos = this.datosGraficoBubble;
      const fmt    = v => Number(v).toLocaleString('es-BO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

      this.chartInstanceBubble = new Chart(ctx.getContext('2d'), {
        type: 'bubble',
        data: {
          datasets: puntos.map(p => ({
            label: p.label,
            data: [{ x: p.x, y: p.y, r: p.r }],
            backgroundColor: p.color,
            borderColor: p.border,
            borderWidth: 1,
          })),
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { position: 'right' },
          onClick: (event, elements) => {
            if (!elements.length || this.unidadSeleccionada) return;
            this.unidadSeleccionada = puntos[elements[0]._datasetIndex].label;
          },
          onHover: (event, elements) => {
            event.target.style.cursor = elements.length && !this.unidadSeleccionada ? 'pointer' : 'default';
          },
          scales: {
            xAxes: [{
              scaleLabel: { display: true, labelString: 'Asignación total (Bs)' },
              ticks: {
                callback: v => Number(v).toLocaleString('es-BO', { maximumFractionDigits: 0 }),
              },
            }],
            yAxes: [{
              scaleLabel: { display: true, labelString: '% Cobranza' },
              ticks: {
                beginAtZero: true,
                max: 100,
                callback: v => `${v}%`,
              },
            }],
          },
          tooltips: {
            callbacks: {
              label: (item, data) => {
                const ds  = data.datasets[item.datasetIndex];
                const pts = ds.data[0];
                const p   = puntos[item.datasetIndex];
                return [
                  ` ${ds.label}`,
                  ` Asignación: ${fmt(pts.x)} Bs.`,
                  ` Cobranza: ${pts.y}%`,
                  ` Estudiantes: ${p.estudiantes}`,
                ];
              },
            },
          },
        },
      });
    },
    renderChartStacked() {
      if (this.chartInstanceStacked) {
        this.chartInstanceStacked.destroy();
        this.chartInstanceStacked = null;
      }
      const ctx = this.$refs.chartStacked;
      if (!ctx) return;

      const d = this.datosGraficoStacked;
      const fmt = v => Number(v).toLocaleString('es-BO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

      this.chartInstanceStacked = new Chart(ctx.getContext('2d'), {
        type: 'bar',
        data: {
          labels: d.labels,
          datasets: [
            {
              label: 'Pagado (Bs)',
              data: d.monto_pagado,
              backgroundColor: 'rgba(56, 142, 60, 0.8)',
              borderColor: '#2e7d32',
              borderWidth: 1,
            },
            {
              label: 'Saldo (Bs)',
              data: d.saldo,
              backgroundColor: 'rgba(229, 57, 53, 0.8)',
              borderColor: '#b71c1c',
              borderWidth: 1,
            },
            {
              label: 'Adelantado (Bs)',
              data: d.monto_adelantado,
              backgroundColor: 'rgba(0, 172, 193, 0.8)',
              borderColor: '#00838f',
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { position: 'top' },
          onClick: (event, elements) => {
            if (!elements.length || this.unidadSeleccionada) return;
            this.unidadSeleccionada = d.labels[elements[0]._index];
          },
          onHover: (event, elements) => {
            event.target.style.cursor = elements.length && !this.unidadSeleccionada ? 'pointer' : 'default';
          },
          scales: {
            xAxes: [{ stacked: true, gridLines: { display: false } }],
            yAxes: [{
              stacked: true,
              ticks: {
                beginAtZero: true,
                callback: v => Number(v).toLocaleString('es-BO', { maximumFractionDigits: 0 }),
              },
            }],
          },
          tooltips: {
            callbacks: {
              label: (item, data) => {
                const ds = data.datasets[item.datasetIndex];
                return `${ds.label}: ${fmt(item.yLabel)} Bs.`;
              },
            },
          },
        },
      });
    },
    renderChartPorcentaje() {
      if (this.chartInstancePorcentaje) {
        this.chartInstancePorcentaje.destroy();
        this.chartInstancePorcentaje = null;
      }
      const ctx = this.$refs.chartPorcentaje;
      if (!ctx) return;

      const d = this.datosGraficoPorcentaje;

      this.chartInstancePorcentaje = new Chart(ctx.getContext('2d'), {
        type: 'horizontalBar',
        data: {
          labels: d.labels,
          datasets: [{
            label: '% Cobranza',
            data: d.porcentaje,
            backgroundColor: d.colores,
            borderWidth: 1,
          }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { display: false },
          onClick: (event, elements) => {
            if (!elements.length || this.unidadSeleccionada) return;
            this.unidadSeleccionada = d.labels[elements[0]._index];
          },
          onHover: (event, elements) => {
            event.target.style.cursor = elements.length && !this.unidadSeleccionada ? 'pointer' : 'default';
          },
          scales: {
            xAxes: [{
              ticks: {
                beginAtZero: true,
                max: 100,
                callback: v => `${v}%`,
              },
            }],
            yAxes: [{ gridLines: { display: false } }],
          },
          tooltips: {
            callbacks: {
              label: (item) => ` ${item.value}%`,
            },
          },
        },
      });
    },
  },
  beforeDestroy() {
    if (this.chartInstance) this.chartInstance.destroy();
    if (this.chartInstanceDoughnut) this.chartInstanceDoughnut.destroy();
    if (this.chartInstanceDia) this.chartInstanceDia.destroy();
    if (this.chartInstanceSemana) this.chartInstanceSemana.destroy();
    if (this.chartInstanceBubble) this.chartInstanceBubble.destroy();
    if (this.chartInstanceStacked) this.chartInstanceStacked.destroy();
    if (this.chartInstancePorcentaje) this.chartInstancePorcentaje.destroy();
  }
};
</script>